import { AxiosInstance } from 'axios';
import Entity from '@/models/Entity';
import { PaginatedResponse } from '@/models/Pagination';

export type GetOperatingSystemsResponse = PaginatedResponse<Entity>;

export default class OperatingSystemController {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  public async getOperatingSystems() {
    const { data } = await this.client.get('/operating-systems', {
      params: {
        offset: 0,
        pageNumber: 1,
        pageSize: 10,
        paged: false
      }
    });
    return data as GetOperatingSystemsResponse;
  }
}
